/**
 * Family Archive Memorial Page credit — pricing & positioning copy (Stage 4B.7).
 * Calm, loyalty-focused — no countdowns or gamified progress in user-facing copy.
 */

export const FAMILY_ARCHIVE_MEMORIAL_CREDIT_MONTHS = 12;

/** Preferred public / pricing line */
export const FAMILY_ARCHIVE_MEMORIAL_CREDIT_PUBLIC_LINE =
  'Family Archive members receive 1 lifetime Memorial Page credit after 12 paid months.';

/** Short badge on Family Archive card */
export const FAMILY_ARCHIVE_MEMORIAL_CREDIT_BADGE =
  'Includes 1 Memorial Page credit after 12 paid months';

/** Primary loyalty line on Family Archive card */
export const FAMILY_ARCHIVE_MEMORIAL_CREDIT_NOTE = FAMILY_ARCHIVE_MEMORIAL_CREDIT_PUBLIC_LINE;

/** Expanded detail copy for Family Archive “What’s included?” */
export const FAMILY_ARCHIVE_MEMORIAL_CREDIT_DETAIL =
  'Build your family archive over time. After 12 paid months, you’ll receive one lifetime Memorial Page credit that can be used for one loved one’s profile whenever your family needs it.';

/** Earned-state headline (account UI — only when backend confirms earned) */
export const MEMORIAL_CREDIT_EARNED_HEADLINE = "You've earned your Memorial Page credit.";

/** Earned-state detail */
export const MEMORIAL_CREDIT_EARNED_DETAIL =
  'Thank you for staying with Family Archive. You now have 1 lifetime Memorial Page credit available for this archive.';

/** Not-yet-earned calm reminder (no countdown) */
export const MEMORIAL_CREDIT_NOT_YET_EARNED_LINE = FAMILY_ARCHIVE_MEMORIAL_CREDIT_PUBLIC_LINE;

/** Memorial Page card — founder / standard pricing line */
export const MEMORIAL_PAGE_PRICING_LINE = '£79 founder’s offer / £99 lifetime later';

/** Memorial Page card — loyalty inclusion line */
export const MEMORIAL_PAGE_FAMILY_ARCHIVE_CREDIT_LINE =
  'Also included as 1 lifetime credit after 12 paid months on Family Archive.';

/** Memorial Page expanded detail — Family Archive credit */
export const MEMORIAL_PAGE_FAMILY_ARCHIVE_CREDIT_DETAIL =
  'Need a Memorial Page now? You can request one separately. Building your archive over time? Family Archive members receive one lifetime Memorial Page credit after 12 paid months.';

/** Gentle workspace note — not a claim of earned credit */
export const FAMILY_ARCHIVE_MEMORIAL_CREDIT_WORKSPACE_NOTE = FAMILY_ARCHIVE_MEMORIAL_CREDIT_PUBLIC_LINE;

/** Phrases that must not appear in user-facing memorial credit copy */
export const MEMORIAL_CREDIT_FORBIDDEN_PHRASES = [
  'free memorial when someone dies',
  'unlimited memorial',
  'guaranteed for everyone',
  'automatic memorialisation',
  'we publish it for you automatically',
  'free when someone dies',
  'countdown to memorial credit',
  'months remaining until',
  'months completed',
  'of 12 paid months completed',
  'of 12 months completed',
];
